// /**
//  * Parcel-Sender -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import {ParcelCSV} from './interfaces';
import {translate, fixToPersianNumbers} from '../../utils/helpers';
import RonadIcons from '../../components/iconComponent';

type Props = {
  parcelsDispatch: any;
  data: ParcelCSV[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const headers = [
    {label: 'شناسه محموله', key: 'id'},
    {label: 'مبدا', key: 'sourceWarehouseName'},
    {label: 'مقصد', key: 'destinationWarehouseName'},
    {label: 'وضعیت', key: 'status'},
    {label: 'تاریخ تحویل', key: 'deliveryDate'},
    {label: 'زمان تحویل', key: 'deliveryTime'},
    {label: 'تاریخ ثبت', key: 'shippingDate'},
    {label: 'تعداد آیتم انبارهای داخل محموله', key: 'items'},
  ];
  const handleCreateCSV = () => {
    props.parcelsDispatch({...props.filtersValues, size: 10000});
  };
  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {
        id: fixToPersianNumbers(item.id.toString()),
        sourceWarehouseName: item.sourceWarehouseName,
        destinationWarehouseName: item.destinationWarehouseName,
        status: translate(item.status, 'parcel'),
        deliveryDate:
          item.deliveryDate &&
          jMoment(item.deliveryDate, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD'),
        deliveryTime:
          item.deliveryDate &&
          jMoment(item.deliveryDate, 'HH:mm:ss')
            .locale('fa')
            .format('HH:mm:ss'),
        shippingDate:
          item.shippingDate &&
          jMoment(item.shippingDate, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD'),
        items: item.itemsCount,
      };
    });
    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          headers={headers}
          separator={','}
          filename="ParcelsSender.csv"
          style={{
            textDecoration: 'none',
          }}
        >
          <Button
            style={{marginLeft: '5px'}}
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<RonadIcons name='download' size={.7} className='text-primary' style={{marginTop: "-4px"}}/>}
          >
            excel
          </Button>
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="outlined"
          color="primary"
          size="large"
          startIcon={<RonadIcons name='plus' size={.6} className='text-primary' style={{marginTop: "-4px"}}/>}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          excel
        </Button>
      )}
    </>
  );
}

export default CSV;
